import { toWorkflowData } from '@data/schemas/workflowData'
import { get } from 'lodash-es'

export const toMembershipData = (data: unknown): MembershipWorkflowData => ({
    laterLink: get(data, 'laterLink'),
    workflow: toWorkflowData(data),
    workflowType: 'membership',
    user: get(data, '_embedded.user'),
})
